// src/components/ui/Logo.jsx
// "Halftone V" dotted logo (Option 3). Pure SVG, no asset dependencies.
// light=true switches dots to white/light-teal for dark backgrounds.
export default function Logo({ height = 28, light = false, className = "" }) {
  const main = light ? "#ffffff" : "#1B5F6E";
  const trail = light ? "#8fd8e6" : "#2A8A9E";
  return (
    <svg
      width={Math.round(height * 1.25)}
      height={height}
      viewBox="0 0 110 88"
      className={className}
      role="img"
      aria-label="Verwendungsnachweis"
    >
      <g fill={main}>
        <circle cx="14" cy="18" r="7.5" />
        <circle cx="40" cy="18" r="7.5" />
        <circle cx="66" cy="18" r="7.5" />
        <circle cx="92" cy="18" r="7.5" />
        <circle cx="27" cy="40" r="6.3" />
        <circle cx="53" cy="40" r="6.3" />
        <circle cx="79" cy="40" r="6.3" />
        <circle cx="40" cy="62" r="5.1" />
        <circle cx="66" cy="62" r="5.1" />
        <circle cx="53" cy="80" r="4.4" />
      </g>
      <g fill={trail} opacity="0.6">
        <circle cx="92" cy="40" r="4.5" />
        <circle cx="100" cy="55" r="3.8" />
        <circle cx="104" cy="70" r="3.1" />
      </g>
    </svg>
  );
}
